// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/druk-wide-bold);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  background: #15191C;
  height: 100%;
}

/* Глобально отключаем подсветку выделения текста и tap highlight */
::selection { background: transparent; color: inherit; }
::-moz-selection { background: transparent; color: inherit; }
* { -webkit-tap-highlight-color: transparent; }

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #15191C;
  color: #ffffff;
  min-height: 100vh;
  min-height: 100dvh;
  line-height: 1.6;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  /* Предотвращаем автоматический скролл при загрузке */
  scroll-behavior: auto;
}

/* Предотвращаем скролл во время загрузки */
body.loading {
  overflow: hidden;
}

/* Анимация загрузки */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #15191C;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  animation: fadeOut 0.3s ease-out 1.5s forwards;
  /* Предотвращаем скролл во время загрузки */
  overflow: hidden;
}

.loading-title {
  font-family: 'Druk Wide Bold', 'Inter', sans-serif;
  font-weight: 900;
  font-size: 2.2rem;
  color: #ffffff;
  margin-bottom: 16px;
  letter-spacing: -0.02em;
}

.loading-progress {
  width: 300px;
  height: 4px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  overflow: hidden;
  position: relative;
}

.loading-progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #C3FF19, #a3df19);
  border-radius: 2px;
  animation: progressFill 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
  box-shadow: 0 0 10px rgba(195, 255, 25, 0.3);
}



@keyframes progressFill {
  0% {
    width: 0%;
  }
  60% {
    width: 40%;
  }
  80% {
    width: 70%;
  }
  100% {
    width: 100%;
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
    visibility: visible;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Page wrapper for full height layout */
.page-wrapper {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  /* Безопасные области для iOS (notch / домашняя панель) */
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.container {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px 20px 40px 20px;
  position: relative;
  animation: fadeIn 0.8s ease-out;
  -webkit-overflow-scrolling: touch;
  flex: 1 1;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.header {
  text-align: center;
  margin-bottom: 80px;
  margin-top: 40px;
}

.header h1 {
  font-size: 4.5rem;
  font-weight: 900;
  font-family: 'Druk Wide Bold', 'Inter', sans-serif;
  color: #C3FF19;
  margin-bottom: 12px;
  letter-spacing: -0.03em;
  animation: slideInDown 1s ease-out;
  text-shadow: none;
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.header p {
  color: #ffffff;
  opacity: 0.9;
  font-family: 'Inter', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 700;
  font-size: 1rem;
  max-width: 600px;
  margin: 0 auto;
  animation: slideInUp 1s ease-out 0.3s both;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.main-content {
  position: relative;
  display: flex;
  gap: 40px;
  align-items: flex-start;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
}

.form-section {
  width: 625px;
  max-width: 625px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 48px 36px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
  animation: slideInUp 1s ease-out 0.5s both;
  z-index: 2;
  position: relative;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.form-section:hover {
  border-color: rgba(195, 255, 25, 0.2);
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.4);
}

/* Кнопка Reset внутри results-section */
.reset-button {
  position: static;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: transparent;
  border: none;
  color: #ffffff; /* белая иконка и текст на десктопе */
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 8px;
  transition: all 0.3s ease;
  width: fit-content;
  margin-top: 20px;
  align-self: center;
}

/* Плавающая кнопка Reset для мобильной версии */
.floating-reset-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: none;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: rgba(195, 255, 25, 0.1);
  border: 2px solid rgba(195, 255, 25, 0.3);
  color: #C3FF19;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 12px 16px;
  border-radius: 50px;
  transition: all 0.3s ease;
  z-index: 1000;
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
}

.floating-reset-button:hover {
  background: rgba(195, 255, 25, 0.2);
  border-color: rgba(195, 255, 25, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.4);
}

.floating-reset-button:active {
  transform: translateY(0);
}

.floating-reset-button svg {
  transition: transform 0.3s ease;
}

.floating-reset-button:hover svg {
  transform: rotate(180deg);
}

/* Анимация появления плавающей кнопки */
@keyframes floatIn {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.8);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.floating-reset-button {
  animation: floatIn 0.5s ease-out;
}

.reset-button:hover {
  color: #ffffff; /* при ховере остаётся белой */
  background: rgba(195, 255, 25, 0.1);
  transform: scale(1.05);
}

.reset-button:active {
  transform: scale(0.95);
}

.reset-button svg {
  transition: transform 0.3s ease;
}

.reset-button:hover svg {
  transform: rotate(180deg);
}

/* Удаляем старые стили для results-column, так как изменили структуру */

.results-section {
  position: sticky;
  top: 40px;
  width: 360px;
  max-width: 360px;
  background: rgba(195, 255, 25, 0.08);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  border: 1px solid rgba(195, 255, 25, 0.2);
  padding: 48px 36px;
  animation: slideInUp 1s ease-out 0.7s both;
  z-index: 1;
  transition: all 0.3s ease;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  /* Стабилизация композитинга для избежания мерцаний */
  contain: paint;
  transform: translateZ(0);
  backface-visibility: hidden;
}

.results-section:hover {
  border-color: rgba(195, 255, 25, 0.3);
}

.form-group {
  margin-bottom: 32px;
  animation: fadeInUp 0.8s ease-out;
  position: relative;
}

/* Управляем z-index для dropdown в зависимости от позиции */
.form-group:nth-child(1) .custom-select { z-index: 10; }
.form-group:nth-child(2) .custom-select { z-index: 9; }
.form-group:nth-child(3) .custom-select { z-index: 8; }
.form-group:nth-child(4) .custom-select { z-index: 7; }
.form-group:nth-child(5) .custom-select { z-index: 6; }
.form-group:nth-child(6) .custom-select { z-index: 5; }
.form-group:nth-child(7) .custom-select { z-index: 4; }
.form-group:nth-child(8) .custom-select { z-index: 3; }
.form-group:nth-child(9) .custom-select { z-index: 2; }
.form-group:nth-child(10) .custom-select { z-index: 1; }

.form-group:nth-child(1) { animation-delay: 0.8s; }
.form-group:nth-child(2) { animation-delay: 0.9s; }
.form-group:nth-child(3) { animation-delay: 1.0s; }
.form-group:nth-child(4) { animation-delay: 1.1s; }
.form-group:nth-child(5) { animation-delay: 1.2s; }
.form-group:nth-child(6) { animation-delay: 1.3s; }

/* Убираем отступ у последнего form-group (Discount) */
.form-group:last-child {
  margin-bottom: 0;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-label {
  display: block;
  margin-bottom: 16px;
  font-weight: 700;
  font-family: 'Inter', sans-serif;
  color: #ffffff;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.9;
  transition: all 0.3s ease;
}

/* Header row: toggle + label in one line */
.form-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.form-header .form-label {
  margin: 0;
}

/* Убираем верхний отступ у тоггла в строке заголовка для точного выравнивания */
.form-header .toggle-group {
  margin-top: 0;
}

.form-label:hover {
  color: inherit;
  opacity: inherit;
}

.form-input {
  width: 100%;
  padding: 16px 20px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  font-size: 16px;
  background: rgba(255, 255, 255, 0.05);
  color: #ffffff;
  transition: all 0.3s ease;
  outline: none;
  backdrop-filter: blur(10px);
}

.form-input:focus {
  border-color: #C3FF19;
  box-shadow: 0 0 0 4px rgba(195, 255, 25, 0.1);
  background-color: rgba(255, 255, 255, 0.08);
  transform: none;
}

/* Убираем стандартные стрелки браузера */
.form-input::-webkit-outer-spin-button,
.form-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.form-input[type=number] {
  appearance: textfield;
  -moz-appearance: textfield;
}

/* Простое числовое поле с кнопками справа */
.number-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.number-input-field {
  width: 100%;
  padding: 16px 20px;
  padding-right: 90px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  font-size: 18px;
  background: rgba(255, 255, 255, 0.05);
  color: #ffffff;
  transition: all 0.3s ease;
  outline: none;
  backdrop-filter: blur(10px);
  text-align: center;
  font-weight: 700;
  font-family: 'Druk Wide Bold', 'Inter', sans-serif;
}

.number-input-field:focus {
  border-color: #C3FF19;
  box-shadow: 0 0 0 4px rgba(195, 255, 25, 0.1);
  background-color: rgba(255, 255, 255, 0.08);
  transform: none;
}

.number-input-field::-webkit-outer-spin-button,
.number-input-field::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.number-input-field[type=number] {
  appearance: textfield;
  -moz-appearance: textfield;
}

.number-controls {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.number-control-btn {
  background: rgba(195, 255, 25, 0.1);
  border: 1px solid rgba(195, 255, 25, 0.2);
  color: #C3FF19;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  min-height: 32px;
}

.number-control-btn:hover:not(:disabled) {
  background: rgba(195, 255, 25, 0.2);
  border-color: rgba(195, 255, 25, 0.3);
  transform: scale(1.1);
  box-shadow: 0 0 10px rgba(195, 255, 25, 0.15);
}

.number-control-btn:active:not(:disabled) {
  transform: scale(0.95);
}

.number-control-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.5);
}

.number-control-btn:disabled:hover {
  transform: none;
  box-shadow: none;
}

/* Горизонтальные кнопки для number input */
.number-controls-horizontal {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: row;
  gap: 4px;
}

/* Кнопка минус слева для number input */
.number-controls-left {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}



.number-control-btn-horizontal {
  background: rgba(195, 255, 25, 0.1);
  border: 1px solid rgba(195, 255, 25, 0.2);
  color: #C3FF19;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  min-height: 32px;
}

.number-control-btn-horizontal:hover:not(:disabled) {
  background: rgba(195, 255, 25, 0.2);
  border-color: rgba(195, 255, 25, 0.3);
  box-shadow: 0 0 10px rgba(195, 255, 25, 0.15);
}

.number-control-btn-horizontal:active:not(:disabled) {
  transform: scale(0.95);
}

.number-control-btn-horizontal:disabled {
  opacity: 0.3;
  cursor: not-allowed;
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.5);
}

.number-control-btn-horizontal:disabled:hover {
  transform: none;
  box-shadow: none;
}

/* Кастомный дропдаун */
.custom-select {
  position: relative;
  width: 100%;
  /* Убеждаемся, что dropdown не наслаивается на другие элементы */
  z-index: 1;
}

/* Когда dropdown открыт, увеличиваем z-index */
.custom-select:has(.custom-select__dropdown) {
  z-index: 9999 !important;
}

/* Предотвращаем наслоение дропдаунов */
.custom-select:has(.custom-select__dropdown) ~ .custom-select {
  z-index: 1 !important;
}

.custom-select__header {
  width: 100%;
  padding: 16px 20px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  font-size: 16px;
  background: rgba(255, 255, 255, 0.05);
  color: #ffffff;
  transition: all 0.3s ease;
  outline: none;
  backdrop-filter: blur(10px);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 56px;
}

.custom-select__header:hover {
  border-color: rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.08);
  /* Убираем transform чтобы дропдаун не менял позицию */
  transform: none;
}

.custom-select__header--open {
  border-color: #C3FF19;
  box-shadow: 0 0 0 4px rgba(195, 255, 25, 0.1);
  background-color: rgba(255, 255, 255, 0.08);
  transform: translateY(-2px);
}

.custom-select__value {
  flex: 1 1;
  color: #ffffff;
}

.custom-select__arrow {
  color: #C3FF19;
  transition: transform 0.3s ease;
  margin-left: 16px;
  flex-shrink: 0;
}

.custom-select__arrow--open {
  transform: rotate(180deg);
}

.custom-select__dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #1a1a1a !important;
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  margin-top: 8px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 9999 !important;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(20px);
  animation: dropdownSlideIn 0.3s ease-out;
  /* Принудительно устанавливаем фон */
  background-color: #1a1a1a !important;
  background-image: none !important;
  /* Убеждаемся, что dropdown поверх всех элементов формы */
  isolation: isolate;
  opacity: 1 !important;
  pointer-events: auto !important;
  /* Предотвращаем изменение позиции при наведении */
  transform: none !important;
  transition: none !important;
}

@keyframes dropdownSlideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
    background: #1a1a1a;
  }
  to {
    opacity: 1;
    transform: translateY(0);
    background: #1a1a1a;
  }
}

/* Дополнительные стили для обеспечения видимости дропдауна */
.custom-select__dropdown {
  opacity: 1 !important;
  visibility: visible !important;
  pointer-events: auto !important;
}

.custom-select__option {
  padding: 12px 20px;
  margin: 12px 8px;
  border-radius: 12px;
  font-size: 16px;
  line-height: 1.5;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #ffffff;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* Принудительно устанавливаем фон для опций */
  background: transparent !important;
  background-color: transparent !important;
  /* Убеждаемся, что опции кликабельны */
  pointer-events: auto !important;
  position: relative;
  z-index: 1;
}

.custom-select__option:hover {
  background: rgba(195, 255, 25, 0.1);
  color: #C3FF19;
  transform: translateX(4px);
}

.custom-select__option--selected {
  background: rgba(195, 255, 25, 0.15);
  color: #C3FF19;
  font-weight: 600;
}

.custom-select__option--selected:hover {
  background: rgba(195, 255, 25, 0.2);
  color: #C3FF19;
}

.custom-select__check {
  color: #C3FF19;
  margin-left: 12px;
  flex-shrink: 0;
}

/* Тогл переключатель */
.toggle-group {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 12px;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 46px; /* чуть меньше по длине */
  height: 26px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.1);
  transition: 0.3s;
  border-radius: 34px;
  border: none;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px; /* круг оставляем меньше */
  width: 18px;
  left: 4px;
  top: 50%;
  transform: translateY(-50%);
  background-color: #ffffff;
  transition: 0.3s;
  border-radius: 50%;
}

input:checked + .toggle-slider {
  background-color: #C3FF19;
  border-color: transparent;
  box-shadow: none;
}

input:checked + .toggle-slider:before {
  transform: translate(20px, -50%); /* (46 - 2*2) - 18 - 4 = 20 */
  background-color: #15191C;
}

/* Убираем фокус-обводку у тоггла */
.toggle-switch input:focus + .toggle-slider,
.toggle-switch input:focus-visible + .toggle-slider {
  outline: none;
  box-shadow: none;
}

.toggle-label {
  font-size: 16px;
  color: #ffffff;
  font-weight: 500;
  transition: color 0.3s ease;
}

input:checked ~ .toggle-label {
  color: #C3FF19;
}

/* Скроллбар для дропдауна */
.custom-select__dropdown::-webkit-scrollbar {
  width: 16px;
}

.custom-select__dropdown::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  margin: 8px;
}

.custom-select__dropdown::-webkit-scrollbar-thumb {
  background: rgba(195, 255, 25, 0.3);
  border-radius: 8px;
  border: 3px solid transparent;
  background-clip: content-box;
}

.custom-select__dropdown::-webkit-scrollbar-thumb:hover {
  background: rgba(195, 255, 25, 0.5);
  background-clip: content-box;
}

.button-group {
  display: flex;
  gap: 16px;
  margin-top: 40px;
  justify-content: flex-start;
  animation: fadeInUp 0.8s ease-out 1.4s both;
}

.btn {
  padding: 16px 32px;
  border: none;
  border-radius: 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 140px;
  position: relative;
  overflow: hidden;
}

.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.btn:hover::before {
  left: 100%;
}

.btn-primary {
  background: #C3FF19;
  color: #15191C;
  box-shadow: 0 8px 25px rgba(195, 255, 25, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 35px rgba(195, 255, 25, 0.4);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border: 2px solid rgba(255, 255, 255, 0.2);
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

.results {
  text-align: left;
}

.result-item {
  margin-bottom: 24px; /* уменьшили расстояние между блоками */
  padding: 0;
  background: transparent;
  border: none;
  transition: all 0.3s ease;
  position: relative;
}

.result-item:last-child {
  margin-bottom: 0;
}

/* У последней цены перед Estimated hours делаем ещё меньше отступ */
.results .result-item:last-of-type {
  margin-bottom: 12px;
}

.result-label {
  font-weight: 700;
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  color: #ffffff;
  opacity: 0.8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
  display: block;
}

.result-subtitle {
  font-size: 0.75rem;
  color: #a0a0a0;
  font-weight: 300;
  margin-bottom: 8px;
  display: block;
  font-style: italic;
}

.result-prices {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.price-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: all 0.3s ease;
  backface-visibility: hidden;
}

.price-item:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.12);
  transform: none;
}

.price-value {
  font-size: 1.4rem;
  font-weight: 900;
  font-family: 'Druk Wide Bold', 'Inter', sans-serif;
  color: #C3FF19;
  text-shadow: none;
  opacity: 1;
}

.copy-button {
  background: transparent;
  border: none;
  color: #C3FF19;
  cursor: pointer;
  padding: 10px;
  border-radius: 10px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
}

.copy-button:hover {
  background: rgba(195, 255, 25, 0.15);
  border: none;
  transform: none;
  box-shadow: none;
}

.copy-button:active {
  transform: scale(0.95);
}

.copy-notification {
  position: absolute;
  top: -15px;
  right: 15px;
  background: #C3FF19;
  color: #15191C;
  padding: 12px 16px;
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: 600;
  animation: notificationSlideIn 0.3s ease-out;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 8px 25px rgba(195, 255, 25, 0.3);
}

@keyframes notificationSlideIn {
  from {
    opacity: 0;
    transform: translateY(-10px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #a0a0a0;
  animation: fadeIn 0.6s ease-out;
}

.empty-state h3 {
  font-size: 1.5rem;
  margin-bottom: 12px;
  color: #ffffff;
}

.empty-state p {
  font-size: 1rem;
  opacity: 0.7;
}

/* Discount buttons styles */
.discount-buttons {
  display: flex;
  gap: 12px;
  margin-top: 16px;
  flex-wrap: wrap;
  width: 100%;
}

.discount-button {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #ffffff;
  padding: 16px 24px;
  border-radius: 12px;
  font-size: 16px; /* как у дропдаунов */
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  flex: 1 1;
  min-width: 80px;
  min-height: 52px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* три кнопки делят ширину равномерно */
.discount-buttons .discount-button { flex: 1 1; }

.discount-button:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
}

.discount-button--active {
  background: rgba(195, 255, 25, 0.12);
  color: #C3FF19;
  border-color: rgba(195, 255, 25, 0.4);
  font-weight: 700;
}

.discount-button--active:hover {
  background: rgba(195, 255, 25, 0.18);
  border-color: rgba(195, 255, 25, 0.5);
  transform: translateY(-1px);
}

/* Input-styled discount button occupying same slot */
.discount-button-input {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #ffffff;
  padding: 16px 24px;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 700;
  font-family: 'Inter', sans-serif;
  width: 100%;
  max-width: 140px;
  transition: all 0.3s ease;
  text-align: center;
}

.discount-button-input:focus {
  border-color: #C3FF19;
  box-shadow: 0 0 0 4px rgba(195, 255, 25, 0.1);
  background: rgba(255, 255, 255, 0.08);
  outline: none;
}
/* Discount input styled like fields */
.discount-input-container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 0;
}

.discount-input {
  width: 100%;
  padding: 16px 20px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  font-size: 16px;
  background: rgba(255, 255, 255, 0.05);
  color: #ffffff;
  transition: all 0.3s ease;
  outline: none;
  backdrop-filter: blur(10px);
  text-align: center;
  font-weight: 600;
}

.discount-input:focus {
  border-color: #C3FF19;
  box-shadow: 0 0 0 4px rgba(195, 255, 25, 0.1);
  background-color: rgba(255, 255, 255, 0.08);
}

.discount-percent-sign {
  color: #C3FF19;
  font-weight: 700;
}

/* New discount rate input like hourly input with +/- */
.discount-rate-input-container {
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 0;
}

.discount-rate-input-container.inline {
  flex: 1 1 auto;
}

.discount-rate-input {
  width: 100%;
  padding: 16px 20px;
  padding-right: 90px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  font-size: 16px;
  background: rgba(255, 255, 255, 0.05);
  color: #ffffff;
  transition: all 0.3s ease;
  outline: none;
  backdrop-filter: blur(10px);
  text-align: center;
  font-weight: 600;
}

.discount-rate-input:focus {
  border-color: #C3FF19;
  box-shadow: 0 0 0 4px rgba(195, 255, 25, 0.1);
  background-color: rgba(255, 255, 255, 0.08);
}

.discount-rate-input::-webkit-outer-spin-button,
.discount-rate-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.discount-rate-input[type=number] {
  appearance: textfield;
  -moz-appearance: textfield;
}

.discount-rate-controls-horizontal {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: row;
  gap: 4px;
}

.discount-rate-control-btn {
  background: rgba(195, 255, 25, 0.1);
  border: 1px solid rgba(195, 255, 25, 0.2);
  color: #C3FF19;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  min-height: 32px;
}

.discount-rate-control-btn:hover:not(:disabled) {
  background: rgba(195, 255, 25, 0.2);
  border-color: rgba(195, 255, 25, 0.3);
  box-shadow: 0 0 10px rgba(195, 255, 25, 0.15);
}

/* Urgency buttons styles (match Discount buttons) */
.urgency-buttons {
  display: flex;
  gap: 16px;
  margin-top: 0;
  flex-wrap: wrap;
  width: 100%;
}

.urgency-button {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #ffffff;
  padding: 16px 28px; /* больше пространства для текста */
  border-radius: 12px;
  font-size: 16px; /* как у дропдаунов */
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  flex: 1 1;
  min-width: 80px;
  min-height: 52px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.urgency-button:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
}

.urgency-button--active {
  background: rgba(195, 255, 25, 0.12);
  color: #C3FF19;
  border-color: rgba(195, 255, 25, 0.4);
  font-weight: 700;
}

.urgency-button--active:hover {
  background: rgba(195, 255, 25, 0.18);
  border-color: rgba(195, 255, 25, 0.5);
  transform: translateY(-1px);
}

/* Estimated hours styles */
.estimated-hours {
  margin-top: 16px; /* уменьшили расстояние от цен */
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
}

.estimated-hours:hover {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.08);
}

.estimated-hours-label {
  font-size: 1rem;
  color: #a0a0a0;
  font-weight: 400;
  letter-spacing: 0.5px;
}

.estimated-hours-value {
  font-size: 1rem;
  font-weight: 600;
  color: #ffffff;
  opacity: 0.8;
}

/* Hourly rate input styles */
.hourly-rate-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.hourly-rate-input {
  width: 100%;
  padding: 16px 20px;
  padding-right: 90px;
  padding-left: 56px; /* как у варианта с кнопкой, аналогично +/- по ширине */
  border: 2px solid rgba(195, 255, 25, 0.3);
  border-radius: 16px;
  font-size: 18px;
  background: rgba(195, 255, 25, 0.05);
  color: #C3FF19;
  transition: all 0.3s ease;
  outline: none;
  backdrop-filter: blur(10px);
  text-align: center;
  font-weight: 700;
  font-family: 'Druk Wide Bold', 'Inter', sans-serif;
}

.hourly-rate-control-btn {
  position: absolute;
  background: rgba(195, 255, 25, 0.1);
  border: 1px solid rgba(195, 255, 25, 0.2);
  color: #C3FF19;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  min-height: 32px;
  z-index: 2;
}

.hourly-rate-control-btn:hover:not(:disabled) {
  background: rgba(195, 255, 25, 0.2);
  border-color: rgba(195, 255, 25, 0.3);
  box-shadow: 0 0 10px rgba(195, 255, 25, 0.15);
}

.hourly-rate-control-btn:active:not(:disabled) {
  transform: scale(0.95);
}

.hourly-rate-control-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.5);
}

.hourly-rate-control-btn:disabled:hover {
  transform: none;
  box-shadow: none;
}

/* Горизонтальные кнопки для hourly rate */
.hourly-rate-controls-horizontal {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: row;
  gap: 4px;
}

/* Позиционирование кнопок для hourly rate */
.hourly-rate-input-container .hourly-rate-control-btn:first-child {
  position: static;
  transform: none;
}

.hourly-rate-input-container .hourly-rate-control-btn:last-child {
  position: static;
  transform: none;
}

.hourly-rate-input:focus {
  border-color: #C3FF19;
  box-shadow: 0 0 0 4px rgba(195, 255, 25, 0.2);
  background-color: rgba(195, 255, 25, 0.08);
  transform: none;
}

.hourly-rate-input:hover {
  border-color: rgba(195, 255, 25, 0.5);
  background-color: rgba(195, 255, 25, 0.08);
}

/* Inline currency select styled as our custom select */
/* Кнопка валюты внутри поля (как +/-) */
.currency-inline-wrapper {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 32px; /* как у кнопок +/- */
  padding-left: 12px; /* отступ от левого края поля */
  padding-right: 12px; /* симметрично справа, чтобы dropdown совпадал по ширине */
  z-index: 10001;
  pointer-events: none; /* кликабельной будет только кнопка */
}
.currency-inline { width: 100%; margin-bottom: 0; }

.currency-inline .custom-select__header {
  height: 32px; /* как у кнопок +/- */
  min-height: 32px !important; /* перекрываем базовый min-height 56px */
  min-width: 40px;
  box-sizing: border-box;
  padding: 8px; /* как у +/- */
  border: 1px solid rgba(195, 255, 25, 0.2);
  background: rgba(195, 255, 25, 0.1); /* как у +/- */
  border-radius: 8px;
  display: inline-flex; /* не растягиваем на всю ширину */
  align-items: center;
  justify-content: center;
  gap: 4px;
  pointer-events: auto; /* кликабельна */
  width: auto !important; /* фиксируем авто-ширину */
  color: #C3FF19; /* как у +/- */
  font-size: 16px;
  line-height: 16px;
  font-weight: 600;
}
.currency-inline .custom-select__arrow {
  width: 16px; /* по требованию */
  height: 16px; /* по требованию */
  display: inline-flex;
  align-items: center;
}

.currency-inline__value {
  color: #C3FF19;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  line-height: 14px; /* вписываемся в 16px высоты */
}

.currency-inline__dropdown {
  left: 0 !important;
  right: 0 !important; /* на всю ширину wrapper, который совпадает с полем */
  min-width: 100% !important;
  z-index: 10002; /* поверх всего */
}

/* Сблизить стрелку с символом и убрать лишний отступ справа */
.currency-inline .custom-select__arrow {
  margin-left: 4px !important;
}

/* Убираем обводки/outline у дропдауна валюты */
.currency-inline .custom-select__header,
.currency-inline .custom-select__header:focus,
.currency-inline .custom-select__header:active {
  outline: none !important;
  box-shadow: none !important;
}

.currency-inline .custom-select__header:hover {
  transform: none;
  background: rgba(195, 255, 25, 0.2); /* как у +/- */
  border-color: rgba(195, 255, 25, 0.3);
  box-shadow: 0 0 10px rgba(195, 255, 25, 0.15);
}

/* Отключаем любые эффекты на кнопке при открытии; анимация остаётся только у иконки */
.currency-inline .custom-select__header--open {
  border: 1px solid rgba(195, 255, 25, 0.2);
  box-shadow: none;
  background-color: rgba(195, 255, 25, 0.1);
  transform: none;
}

.currency-inline .custom-select__header:active {
  transform: scale(0.95);
}

.hourly-rate-input::-webkit-outer-spin-button,
.hourly-rate-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.hourly-rate-input[type=number] {
  appearance: textfield;
  -moz-appearance: textfield;
}

/* Hourly rate display styles (for results) */
.hourly-rate {
  margin-top: 20px;
  padding: 20px 24px;
  background: rgba(195, 255, 25, 0.05);
  border-radius: 12px;
  border: 1px solid rgba(195, 255, 25, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
}

.hourly-rate:hover {
  background: rgba(195, 255, 25, 0.08);
  border-color: rgba(195, 255, 25, 0.15);
}

.hourly-rate-label {
  font-size: 1rem;
  color: #a0a0a0;
  font-weight: 400;
  letter-spacing: 0.5px;
}

.hourly-rate-value {
  font-size: 1rem;
  font-weight: 600;
  color: #C3FF19;
  opacity: 0.9;
}

/* Version info styles */
.version-info {
  margin-top: 60px;
  padding: 20px 0;
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  background: rgba(0, 0, 0, 0.1);
}

/* Расширение фона футера на нижнюю безопасную область */
.footer-extension {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: env(safe-area-inset-bottom);
  height: constant(safe-area-inset-bottom);
  background: rgba(0, 0, 0, 0.1);
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  pointer-events: none;
  z-index: 1;
}

.version-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.version-main {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}

.version-text {
  font-size: 0.75rem;
  font-weight: 400;
  color: #666666;
}

.version-copyright {
  display: flex;
  align-items: center;
  justify-content: center;
}

.copyright-text {
  font-size: 0.65rem;
  color: #555555;
  font-weight: 300;
}

@media (max-width: 1200px) {
  .main-content {
    max-width: 1000px;
    gap: 30px;
  }
  
  .form-section {
    width: 550px;
    padding: 40px;
  }
  
  .results-section {
    width: 340px;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 20px 16px;
    flex: 1 1;
  }
  
  .main-content {
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
  
  /* Заголовки и подзаголовок на мобильных */
  .header h1 {
    font-size: 3.2rem;
    line-height: 1.05;
  }
  .header p {
    font-size: 0.85rem;
    line-height: 1.4;
  }
  
  /* Исправляем проблемы с dropdown на мобильных */
  .custom-select__dropdown {
    z-index: 99999 !important;
    background: #1a1a1a !important;
    background-color: #1a1a1a !important;
    position: fixed !important;
    top: auto !important;
    left: 16px !important;
    right: 16px !important;
    max-height: 300px !important;
    overflow-y: auto !important;
    opacity: 1 !important;
    pointer-events: auto !important;
    transform: none !important;
    transition: none !important;
  }
  /* Дропдаун валюты — те же правила, во всю ширину поля/экрана */
  .currency-inline__dropdown {
    z-index: 99999 !important;
    background: #1a1a1a !important;
    background-color: #1a1a1a !important;
    position: absolute !important; /* от контейнера валюты */
    top: calc(100% + 8px) !important; /* под кнопкой валюты */
    left: 0 !important;
    right: 0 !important; /* ровно по ширине input (через wrapper) */
    max-height: 300px !important;
    overflow-y: auto !important;
    opacity: 1 !important;
    pointer-events: auto !important;
    transform: none !important;
    transition: none !important;
  }
  
  /* На мобильных все dropdown имеют одинаковый z-index */
  .form-group .custom-select {
    z-index: 1 !important;
  }
  
  /* Когда dropdown открыт на мобильных */
  .form-group .custom-select:has(.custom-select__dropdown) {
    z-index: 99999 !important;
  }
  
  .form-section {
    width: 100%;
    max-width: 500px;
    padding: 32px 24px;
    order: 2;
  }
  
  .results-section {
    position: static;
    width: 100%;
    max-width: 500px;
    padding: 32px 24px; /* те же паддинги, что у form-section */
    order: 1;
    margin-top: 0;
  }

  /* Цены в столбик на мобильных */
  .result-prices { flex-direction: column; gap: 16px; align-items: stretch; }
  .price-item {
    padding: 20px 24px;
    border-radius: 12px;
  }
  .price-value { font-size: 1.2rem; }

  /* Компактный empty state */
  .empty-state { padding: 12px 8px; }
  .empty-state h3 { font-size: 1rem; margin-bottom: 4px; }
  .empty-state p { font-size: 0.8rem; }
  
  /* Убираем дублирующиеся стили для results-column */
  
  .header h1 {
    font-size: 2.5rem;
  }
  
  .button-group {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .btn {
    width: 100%;
    max-width: 300px;
  }
  
  .price-value {
    font-size: 1.2rem;
  }
  
  .copy-button {
    min-width: 40px;
    min-height: 40px;
    padding: 8px;
  }
  
  .number-control-btn {
    min-width: 28px;
    min-height: 28px;
    padding: 6px;
  }
  
  .number-input-field {
    padding-right: 70px;
  }

  .version-info {
    margin-top: 80px; /* увеличили расстояние от контента до футера */
    padding: 16px 0;
    margin-bottom: 88px; /* чуть больше для плавающей кнопки */
  }
  
  .version-main {
    flex-direction: column;
    gap: 4px;
  }
  
  .version-copyright {
    flex-direction: column;
    gap: 4px;
  }
  
  /* Показываем плавающую кнопку Reset на мобильных */
  .floating-reset-button {
    display: flex;
  }
  
  /* Скрываем обычную кнопку Reset на мобильных */
  .reset-button {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAKA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,mEAAmE;AACnE,cAAc,uBAAuB,EAAE,cAAc,EAAE;AACvD,mBAAmB,uBAAuB,EAAE,cAAc,EAAE;AAC5D,IAAI,wCAAwC,EAAE;;AAE9C;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,8CAA8C;EAC9C,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,0EAA0E;EAC1E,4CAA4C;AAC9C;;;;AAIA;EACE;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;aACW;AACb;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,yDAAyD;EACzD,0CAA0C;EAC1C,qCAAqC;EACrC,gDAAgD;EAChD,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;EAClB,+BAA+B;EAC/B,iCAAiC;EACjC,SAAO;AACT;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kDAAkD;EAClD,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,cAAc,EAAE,qCAAqC;EACrD,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc,EAAE,8BAA8B;EAC9C,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wEAAwE;;AAExE;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,0CAA0C;EAC1C,UAAU;EACV,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,qDAAqD;EACrD,cAAc;EAEd,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA,4DAA4D;AAC5D,0CAA0C,WAAW,EAAE;AACvD,0CAA0C,UAAU,EAAE;AACtD,0CAA0C,UAAU,EAAE;AACtD,0CAA0C,UAAU,EAAE;AACtD,0CAA0C,UAAU,EAAE;AACtD,0CAA0C,UAAU,EAAE;AACtD,0CAA0C,UAAU,EAAE;AACtD,0CAA0C,UAAU,EAAE;AACtD,0CAA0C,UAAU,EAAE;AACtD,2CAA2C,UAAU,EAAE;;AAEvD,2BAA2B,qBAAqB,EAAE;AAClD,2BAA2B,qBAAqB,EAAE;AAClD,2BAA2B,qBAAqB,EAAE;AAClD,2BAA2B,qBAAqB,EAAE;AAClD,2BAA2B,qBAAqB,EAAE;AAClD,2BAA2B,qBAAqB,EAAE;;AAElD,sDAAsD;AACtD;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA,gFAAgF;AAChF;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,2CAA2C;EAC3C,eAAe;AACjB;;AAEA,yCAAyC;AACzC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;;AAIA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,WAAW;EACX,gEAAgE;EAChE,UAAU;AACZ;;AAEA,+CAA+C;AAC/C;EACE,wBAAwB;AAC1B;;AAEA,uCAAuC;AACvC;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,sDAAsD;EACtD,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,0CAA0C;EAC1C,2BAA2B;EAC3B,wCAAwC;EACxC,oCAAoC;EACpC,oCAAoC;EACpC,iCAAiC;EACjC,yDAAyD;EACzD,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;EAC/B,kDAAkD;EAClD,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;IAC5B,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,wBAAwB;IACxB,mBAAmB;EACrB;AACF;;AAEA,6DAA6D;AAC7D;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,8CAA8C;EAC9C,kCAAkC;EAClC,wCAAwC;EACxC,sCAAsC;EACtC,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW,EAAE,yBAAyB;EACtC,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C;EAC1C,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAE,0BAA0B;EACxC,WAAW;EACX,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC,EAAE,6BAA6B;EAC/D,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB,EAAE,uCAAuC;EAC5D,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;EAC3C,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kDAAkD;EAClD,cAAc;EACd,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,4CAA4C;EAC5C,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8CAA8C;AAChD;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe,EAAE,qBAAqB;EACtC,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,yBAAyB;EACzB,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,uCAAuC;AACvC,qCAAqC,SAAW,EAAE;;AAElD;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA,qDAAqD;AACrD;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,qCAAqC;EACrC,aAAa;AACf;AACA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;EACd,kBAAkB,EAAE,mCAAmC;EACvD,mBAAmB;EACnB,eAAe,EAAE,qBAAqB;EACtC,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,yBAAyB;EACzB,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB,EAAE,gCAAgC;EAClD,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB,EAAE,uDAAuD;EAC3E,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,oCAAoC;EACpC,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA,uDAAuD;AACvD,wCAAwC;AACxC;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,YAAY,EAAE,qBAAqB;EACnC,kBAAkB,EAAE,+BAA+B;EACnD,mBAAmB,EAAE,0DAA0D;EAC/E,cAAc;EACd,oBAAoB,EAAE,qCAAqC;AAC7D;AACA,mBAAmB,WAAW,EAAE,gBAAgB,EAAE;;AAElD;EACE,YAAY,EAAE,qBAAqB;EACnC,2BAA2B,EAAE,wCAAwC;EACrE,eAAe;EACf,sBAAsB;EACtB,YAAY,EAAE,cAAc;EAC5B,yCAAyC;EACzC,mCAAmC,EAAE,cAAc;EACnD,kBAAkB;EAClB,oBAAoB,EAAE,iCAAiC;EACvD,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB,EAAE,gBAAgB;EACtC,sBAAsB,EAAE,0BAA0B;EAClD,cAAc,EAAE,cAAc;EAC9B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW,EAAE,kBAAkB;EAC/B,YAAY,EAAE,kBAAkB;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB,EAAE,8BAA8B;AACnD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB,EAAE,qDAAqD;EAC1E,0BAA0B;EAC1B,cAAc,EAAE,iBAAiB;AACnC;;AAEA,8DAA8D;AAC9D;EACE,2BAA2B;AAC7B;;AAEA,+CAA+C;AAC/C;;;EAGE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,mCAAmC,EAAE,cAAc;EACnD,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA,sFAAsF;AACtF;EACE,yCAAyC;EACzC,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,+CAA+C;EAC/C,8BAA8B;AAChC;;AAEA,wDAAwD;AACxD;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,wCAAwC;EACxC,8BAA8B;EAC9B,+CAA+C;EAC/C,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,SAAO;EACT;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA,0CAA0C;EAC1C;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,gDAAgD;EAChD;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,oCAAoC;IACpC,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;IACrB,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA,+DAA+D;EAC/D;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,oCAAoC;IACpC,6BAA6B,EAAE,yBAAyB;IACxD,gCAAgC,EAAE,uBAAuB;IACzD,kBAAkB;IAClB,mBAAmB,EAAE,0CAA0C;IAC/D,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;IACrB,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA,uDAAuD;EACvD;IACE,qBAAqB;EACvB;;EAEA,uCAAuC;EACvC;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,kBAAkB,EAAE,uCAAuC;IAC3D,QAAQ;IACR,aAAa;EACf;;EAEA,gCAAgC;EAChC,iBAAiB,sBAAsB,EAAE,SAAS,EAAE,oBAAoB,EAAE;EAC1E;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA,eAAe,iBAAiB,EAAE;;EAElC,2BAA2B;EAC3B,eAAe,iBAAiB,EAAE;EAClC,kBAAkB,eAAe,EAAE,kBAAkB,EAAE;EACvD,iBAAiB,iBAAiB,EAAE;;EAEpC,mDAAmD;;EAEnD;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB,EAAE,+CAA+C;IACjE,eAAe;IACf,mBAAmB,EAAE,qCAAqC;EAC5D;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA,mDAAmD;EACnD;IACE,aAAa;EACf;;EAEA,+CAA+C;EAC/C;IACE,aAAa;EACf;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');\n@import url('https://fonts.cdnfonts.com/css/druk-wide-bold');\n\nhtml {\n  background: #15191C;\n  height: 100%;\n}\n\n/* Глобально отключаем подсветку выделения текста и tap highlight */\n::selection { background: transparent; color: inherit; }\n::-moz-selection { background: transparent; color: inherit; }\n* { -webkit-tap-highlight-color: transparent; }\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: #15191C;\n  color: #ffffff;\n  min-height: 100vh;\n  min-height: 100dvh;\n  line-height: 1.6;\n  -webkit-overflow-scrolling: touch;\n  overflow-x: hidden;\n  /* Предотвращаем автоматический скролл при загрузке */\n  scroll-behavior: auto;\n}\n\n/* Предотвращаем скролл во время загрузки */\nbody.loading {\n  overflow: hidden;\n}\n\n/* Анимация загрузки */\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #15191C;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 99999;\n  animation: fadeOut 0.3s ease-out 1.5s forwards;\n  /* Предотвращаем скролл во время загрузки */\n  overflow: hidden;\n}\n\n.loading-title {\n  font-family: 'Druk Wide Bold', 'Inter', sans-serif;\n  font-weight: 900;\n  font-size: 2.2rem;\n  color: #ffffff;\n  margin-bottom: 16px;\n  letter-spacing: -0.02em;\n}\n\n.loading-progress {\n  width: 300px;\n  height: 4px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 2px;\n  overflow: hidden;\n  position: relative;\n}\n\n.loading-progress-bar {\n  height: 100%;\n  background: linear-gradient(90deg, #C3FF19, #a3df19);\n  border-radius: 2px;\n  animation: progressFill 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;\n  box-shadow: 0 0 10px rgba(195, 255, 25, 0.3);\n}\n\n\n\n@keyframes progressFill {\n  0% {\n    width: 0%;\n  }\n  60% {\n    width: 40%;\n  }\n  80% {\n    width: 70%;\n  }\n  100% {\n    width: 100%;\n  }\n}\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n    visibility: visible;\n  }\n  100% {\n    opacity: 0;\n    visibility: hidden;\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Page wrapper for full height layout */\n.page-wrapper {\n  min-height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  /* Безопасные области для iOS (notch / домашняя панель) */\n  padding-top: constant(safe-area-inset-top);\n  padding-top: env(safe-area-inset-top);\n  padding-bottom: constant(safe-area-inset-bottom);\n  padding-bottom: env(safe-area-inset-bottom);\n}\n\n.container {\n  width: 100%;\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 40px 20px 40px 20px;\n  position: relative;\n  animation: fadeIn 0.8s ease-out;\n  -webkit-overflow-scrolling: touch;\n  flex: 1;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.header {\n  text-align: center;\n  margin-bottom: 80px;\n  margin-top: 40px;\n}\n\n.header h1 {\n  font-size: 4.5rem;\n  font-weight: 900;\n  font-family: 'Druk Wide Bold', 'Inter', sans-serif;\n  color: #C3FF19;\n  margin-bottom: 12px;\n  letter-spacing: -0.03em;\n  animation: slideInDown 1s ease-out;\n  text-shadow: none;\n}\n\n@keyframes slideInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-40px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.header p {\n  color: #ffffff;\n  opacity: 0.9;\n  font-family: 'Inter', sans-serif;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 700;\n  font-size: 1rem;\n  max-width: 600px;\n  margin: 0 auto;\n  animation: slideInUp 1s ease-out 0.3s both;\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(40px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.main-content {\n  position: relative;\n  display: flex;\n  gap: 40px;\n  align-items: flex-start;\n  justify-content: center;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.form-section {\n  width: 625px;\n  max-width: 625px;\n  background: rgba(255, 255, 255, 0.03);\n  backdrop-filter: blur(20px);\n  border-radius: 24px;\n  padding: 48px 36px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);\n  animation: slideInUp 1s ease-out 0.5s both;\n  z-index: 2;\n  position: relative;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n}\n\n.form-section:hover {\n  border-color: rgba(195, 255, 25, 0.2);\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.4);\n}\n\n/* Кнопка Reset внутри results-section */\n.reset-button {\n  position: static;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: transparent;\n  border: none;\n  color: #ffffff; /* белая иконка и текст на десктопе */\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 8px 12px;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  width: fit-content;\n  margin-top: 20px;\n  align-self: center;\n}\n\n/* Плавающая кнопка Reset для мобильной версии */\n.floating-reset-button {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: rgba(195, 255, 25, 0.1);\n  border: 2px solid rgba(195, 255, 25, 0.3);\n  color: #C3FF19;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 12px 16px;\n  border-radius: 50px;\n  transition: all 0.3s ease;\n  z-index: 1000;\n  backdrop-filter: blur(10px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);\n}\n\n.floating-reset-button:hover {\n  background: rgba(195, 255, 25, 0.2);\n  border-color: rgba(195, 255, 25, 0.5);\n  transform: translateY(-2px);\n  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.4);\n}\n\n.floating-reset-button:active {\n  transform: translateY(0);\n}\n\n.floating-reset-button svg {\n  transition: transform 0.3s ease;\n}\n\n.floating-reset-button:hover svg {\n  transform: rotate(180deg);\n}\n\n/* Анимация появления плавающей кнопки */\n@keyframes floatIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.floating-reset-button {\n  animation: floatIn 0.5s ease-out;\n}\n\n.reset-button:hover {\n  color: #ffffff; /* при ховере остаётся белой */\n  background: rgba(195, 255, 25, 0.1);\n  transform: scale(1.05);\n}\n\n.reset-button:active {\n  transform: scale(0.95);\n}\n\n.reset-button svg {\n  transition: transform 0.3s ease;\n}\n\n.reset-button:hover svg {\n  transform: rotate(180deg);\n}\n\n/* Удаляем старые стили для results-column, так как изменили структуру */\n\n.results-section {\n  position: sticky;\n  top: 40px;\n  width: 360px;\n  max-width: 360px;\n  background: rgba(195, 255, 25, 0.08);\n  backdrop-filter: blur(20px);\n  border-radius: 20px;\n  border: 1px solid rgba(195, 255, 25, 0.2);\n  padding: 48px 36px;\n  animation: slideInUp 1s ease-out 0.7s both;\n  z-index: 1;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  /* Стабилизация композитинга для избежания мерцаний */\n  contain: paint;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n  backface-visibility: hidden;\n}\n\n.results-section:hover {\n  border-color: rgba(195, 255, 25, 0.3);\n}\n\n.form-group {\n  margin-bottom: 32px;\n  animation: fadeInUp 0.8s ease-out;\n  position: relative;\n}\n\n/* Управляем z-index для dropdown в зависимости от позиции */\n.form-group:nth-child(1) .custom-select { z-index: 10; }\n.form-group:nth-child(2) .custom-select { z-index: 9; }\n.form-group:nth-child(3) .custom-select { z-index: 8; }\n.form-group:nth-child(4) .custom-select { z-index: 7; }\n.form-group:nth-child(5) .custom-select { z-index: 6; }\n.form-group:nth-child(6) .custom-select { z-index: 5; }\n.form-group:nth-child(7) .custom-select { z-index: 4; }\n.form-group:nth-child(8) .custom-select { z-index: 3; }\n.form-group:nth-child(9) .custom-select { z-index: 2; }\n.form-group:nth-child(10) .custom-select { z-index: 1; }\n\n.form-group:nth-child(1) { animation-delay: 0.8s; }\n.form-group:nth-child(2) { animation-delay: 0.9s; }\n.form-group:nth-child(3) { animation-delay: 1.0s; }\n.form-group:nth-child(4) { animation-delay: 1.1s; }\n.form-group:nth-child(5) { animation-delay: 1.2s; }\n.form-group:nth-child(6) { animation-delay: 1.3s; }\n\n/* Убираем отступ у последнего form-group (Discount) */\n.form-group:last-child {\n  margin-bottom: 0;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.form-label {\n  display: block;\n  margin-bottom: 16px;\n  font-weight: 700;\n  font-family: 'Inter', sans-serif;\n  color: #ffffff;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  opacity: 0.9;\n  transition: all 0.3s ease;\n}\n\n/* Header row: toggle + label in one line */\n.form-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.form-header .form-label {\n  margin: 0;\n}\n\n/* Убираем верхний отступ у тоггла в строке заголовка для точного выравнивания */\n.form-header .toggle-group {\n  margin-top: 0;\n}\n\n.form-label:hover {\n  color: inherit;\n  opacity: inherit;\n}\n\n.form-input {\n  width: 100%;\n  padding: 16px 20px;\n  border: 2px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  font-size: 16px;\n  background: rgba(255, 255, 255, 0.05);\n  color: #ffffff;\n  transition: all 0.3s ease;\n  outline: none;\n  backdrop-filter: blur(10px);\n}\n\n.form-input:focus {\n  border-color: #C3FF19;\n  box-shadow: 0 0 0 4px rgba(195, 255, 25, 0.1);\n  background-color: rgba(255, 255, 255, 0.08);\n  transform: none;\n}\n\n/* Убираем стандартные стрелки браузера */\n.form-input::-webkit-outer-spin-button,\n.form-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.form-input[type=number] {\n  appearance: textfield;\n  -moz-appearance: textfield;\n}\n\n/* Простое числовое поле с кнопками справа */\n.number-input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.number-input-field {\n  width: 100%;\n  padding: 16px 20px;\n  padding-right: 90px;\n  border: 2px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  font-size: 18px;\n  background: rgba(255, 255, 255, 0.05);\n  color: #ffffff;\n  transition: all 0.3s ease;\n  outline: none;\n  backdrop-filter: blur(10px);\n  text-align: center;\n  font-weight: 700;\n  font-family: 'Druk Wide Bold', 'Inter', sans-serif;\n}\n\n.number-input-field:focus {\n  border-color: #C3FF19;\n  box-shadow: 0 0 0 4px rgba(195, 255, 25, 0.1);\n  background-color: rgba(255, 255, 255, 0.08);\n  transform: none;\n}\n\n.number-input-field::-webkit-outer-spin-button,\n.number-input-field::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.number-input-field[type=number] {\n  appearance: textfield;\n  -moz-appearance: textfield;\n}\n\n.number-controls {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.number-control-btn {\n  background: rgba(195, 255, 25, 0.1);\n  border: 1px solid rgba(195, 255, 25, 0.2);\n  color: #C3FF19;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 32px;\n  min-height: 32px;\n}\n\n.number-control-btn:hover:not(:disabled) {\n  background: rgba(195, 255, 25, 0.2);\n  border-color: rgba(195, 255, 25, 0.3);\n  transform: scale(1.1);\n  box-shadow: 0 0 10px rgba(195, 255, 25, 0.15);\n}\n\n.number-control-btn:active:not(:disabled) {\n  transform: scale(0.95);\n}\n\n.number-control-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.number-control-btn:disabled:hover {\n  transform: none;\n  box-shadow: none;\n}\n\n/* Горизонтальные кнопки для number input */\n.number-controls-horizontal {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n}\n\n/* Кнопка минус слева для number input */\n.number-controls-left {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n\n.number-control-btn-horizontal {\n  background: rgba(195, 255, 25, 0.1);\n  border: 1px solid rgba(195, 255, 25, 0.2);\n  color: #C3FF19;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 32px;\n  min-height: 32px;\n}\n\n.number-control-btn-horizontal:hover:not(:disabled) {\n  background: rgba(195, 255, 25, 0.2);\n  border-color: rgba(195, 255, 25, 0.3);\n  box-shadow: 0 0 10px rgba(195, 255, 25, 0.15);\n}\n\n.number-control-btn-horizontal:active:not(:disabled) {\n  transform: scale(0.95);\n}\n\n.number-control-btn-horizontal:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.number-control-btn-horizontal:disabled:hover {\n  transform: none;\n  box-shadow: none;\n}\n\n/* Кастомный дропдаун */\n.custom-select {\n  position: relative;\n  width: 100%;\n  /* Убеждаемся, что dropdown не наслаивается на другие элементы */\n  z-index: 1;\n}\n\n/* Когда dropdown открыт, увеличиваем z-index */\n.custom-select:has(.custom-select__dropdown) {\n  z-index: 9999 !important;\n}\n\n/* Предотвращаем наслоение дропдаунов */\n.custom-select:has(.custom-select__dropdown) ~ .custom-select {\n  z-index: 1 !important;\n}\n\n.custom-select__header {\n  width: 100%;\n  padding: 16px 20px;\n  border: 2px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  font-size: 16px;\n  background: rgba(255, 255, 255, 0.05);\n  color: #ffffff;\n  transition: all 0.3s ease;\n  outline: none;\n  backdrop-filter: blur(10px);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 56px;\n}\n\n.custom-select__header:hover {\n  border-color: rgba(255, 255, 255, 0.2);\n  background: rgba(255, 255, 255, 0.08);\n  /* Убираем transform чтобы дропдаун не менял позицию */\n  transform: none;\n}\n\n.custom-select__header--open {\n  border-color: #C3FF19;\n  box-shadow: 0 0 0 4px rgba(195, 255, 25, 0.1);\n  background-color: rgba(255, 255, 255, 0.08);\n  transform: translateY(-2px);\n}\n\n.custom-select__value {\n  flex: 1;\n  color: #ffffff;\n}\n\n.custom-select__arrow {\n  color: #C3FF19;\n  transition: transform 0.3s ease;\n  margin-left: 16px;\n  flex-shrink: 0;\n}\n\n.custom-select__arrow--open {\n  transform: rotate(180deg);\n}\n\n.custom-select__dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: #1a1a1a !important;\n  border: 2px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  margin-top: 8px;\n  max-height: 300px;\n  overflow-y: auto;\n  z-index: 9999 !important;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(20px);\n  animation: dropdownSlideIn 0.3s ease-out;\n  /* Принудительно устанавливаем фон */\n  background-color: #1a1a1a !important;\n  background-image: none !important;\n  /* Убеждаемся, что dropdown поверх всех элементов формы */\n  isolation: isolate;\n  opacity: 1 !important;\n  pointer-events: auto !important;\n  /* Предотвращаем изменение позиции при наведении */\n  transform: none !important;\n  transition: none !important;\n}\n\n@keyframes dropdownSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n    background: #1a1a1a;\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n    background: #1a1a1a;\n  }\n}\n\n/* Дополнительные стили для обеспечения видимости дропдауна */\n.custom-select__dropdown {\n  opacity: 1 !important;\n  visibility: visible !important;\n  pointer-events: auto !important;\n}\n\n.custom-select__option {\n  padding: 12px 20px;\n  margin: 12px 8px;\n  border-radius: 12px;\n  font-size: 16px;\n  line-height: 1.5;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: #ffffff;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  /* Принудительно устанавливаем фон для опций */\n  background: transparent !important;\n  background-color: transparent !important;\n  /* Убеждаемся, что опции кликабельны */\n  pointer-events: auto !important;\n  position: relative;\n  z-index: 1;\n}\n\n.custom-select__option:hover {\n  background: rgba(195, 255, 25, 0.1);\n  color: #C3FF19;\n  transform: translateX(4px);\n}\n\n.custom-select__option--selected {\n  background: rgba(195, 255, 25, 0.15);\n  color: #C3FF19;\n  font-weight: 600;\n}\n\n.custom-select__option--selected:hover {\n  background: rgba(195, 255, 25, 0.2);\n  color: #C3FF19;\n}\n\n.custom-select__check {\n  color: #C3FF19;\n  margin-left: 12px;\n  flex-shrink: 0;\n}\n\n/* Тогл переключатель */\n.toggle-group {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-top: 12px;\n}\n\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 46px; /* чуть меньше по длине */\n  height: 26px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.1);\n  transition: 0.3s;\n  border-radius: 34px;\n  border: none;\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px; /* круг оставляем меньше */\n  width: 18px;\n  left: 4px;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: #ffffff;\n  transition: 0.3s;\n  border-radius: 50%;\n}\n\ninput:checked + .toggle-slider {\n  background-color: #C3FF19;\n  border-color: transparent;\n  box-shadow: none;\n}\n\ninput:checked + .toggle-slider:before {\n  transform: translate(20px, -50%); /* (46 - 2*2) - 18 - 4 = 20 */\n  background-color: #15191C;\n}\n\n/* Убираем фокус-обводку у тоггла */\n.toggle-switch input:focus + .toggle-slider,\n.toggle-switch input:focus-visible + .toggle-slider {\n  outline: none;\n  box-shadow: none;\n}\n\n.toggle-label {\n  font-size: 16px;\n  color: #ffffff;\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\ninput:checked ~ .toggle-label {\n  color: #C3FF19;\n}\n\n/* Скроллбар для дропдауна */\n.custom-select__dropdown::-webkit-scrollbar {\n  width: 16px;\n}\n\n.custom-select__dropdown::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  margin: 8px;\n}\n\n.custom-select__dropdown::-webkit-scrollbar-thumb {\n  background: rgba(195, 255, 25, 0.3);\n  border-radius: 8px;\n  border: 3px solid transparent;\n  background-clip: content-box;\n}\n\n.custom-select__dropdown::-webkit-scrollbar-thumb:hover {\n  background: rgba(195, 255, 25, 0.5);\n  background-clip: content-box;\n}\n\n.button-group {\n  display: flex;\n  gap: 16px;\n  margin-top: 40px;\n  justify-content: flex-start;\n  animation: fadeInUp 0.8s ease-out 1.4s both;\n}\n\n.btn {\n  padding: 16px 32px;\n  border: none;\n  border-radius: 16px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  min-width: 140px;\n  position: relative;\n  overflow: hidden;\n}\n\n.btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s;\n}\n\n.btn:hover::before {\n  left: 100%;\n}\n\n.btn-primary {\n  background: #C3FF19;\n  color: #15191C;\n  box-shadow: 0 8px 25px rgba(195, 255, 25, 0.3);\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 12px 35px rgba(195, 255, 25, 0.4);\n}\n\n.btn-secondary {\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n}\n\n.btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.15);\n  border-color: rgba(255, 255, 255, 0.3);\n  transform: translateY(-2px);\n}\n\n.results {\n  text-align: left;\n}\n\n.result-item {\n  margin-bottom: 24px; /* уменьшили расстояние между блоками */\n  padding: 0;\n  background: transparent;\n  border: none;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.result-item:last-child {\n  margin-bottom: 0;\n}\n\n/* У последней цены перед Estimated hours делаем ещё меньше отступ */\n.results .result-item:last-of-type {\n  margin-bottom: 12px;\n}\n\n.result-label {\n  font-weight: 700;\n  font-family: 'Inter', sans-serif;\n  font-size: 0.85rem;\n  color: #ffffff;\n  opacity: 0.8;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 12px;\n  display: block;\n}\n\n.result-subtitle {\n  font-size: 0.75rem;\n  color: #a0a0a0;\n  font-weight: 300;\n  margin-bottom: 8px;\n  display: block;\n  font-style: italic;\n}\n\n.result-prices {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.price-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  transition: all 0.3s ease;\n  backface-visibility: hidden;\n}\n\n.price-item:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.12);\n  transform: none;\n}\n\n.price-value {\n  font-size: 1.4rem;\n  font-weight: 900;\n  font-family: 'Druk Wide Bold', 'Inter', sans-serif;\n  color: #C3FF19;\n  text-shadow: none;\n  opacity: 1;\n}\n\n.copy-button {\n  background: transparent;\n  border: none;\n  color: #C3FF19;\n  cursor: pointer;\n  padding: 10px;\n  border-radius: 10px;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 44px;\n  min-height: 44px;\n}\n\n.copy-button:hover {\n  background: rgba(195, 255, 25, 0.15);\n  border: none;\n  transform: none;\n  box-shadow: none;\n}\n\n.copy-button:active {\n  transform: scale(0.95);\n}\n\n.copy-notification {\n  position: absolute;\n  top: -15px;\n  right: 15px;\n  background: #C3FF19;\n  color: #15191C;\n  padding: 12px 16px;\n  border-radius: 12px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  animation: notificationSlideIn 0.3s ease-out;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 8px 25px rgba(195, 255, 25, 0.3);\n}\n\n@keyframes notificationSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px) scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.8;\n  }\n}\n\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: #a0a0a0;\n  animation: fadeIn 0.6s ease-out;\n}\n\n.empty-state h3 {\n  font-size: 1.5rem;\n  margin-bottom: 12px;\n  color: #ffffff;\n}\n\n.empty-state p {\n  font-size: 1rem;\n  opacity: 0.7;\n}\n\n/* Discount buttons styles */\n.discount-buttons {\n  display: flex;\n  gap: 12px;\n  margin-top: 16px;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.discount-button {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n  padding: 16px 24px;\n  border-radius: 12px;\n  font-size: 16px; /* как у дропдаунов */\n  font-weight: 600;\n  font-family: 'Inter', sans-serif;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  flex: 1;\n  min-width: 80px;\n  min-height: 52px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* три кнопки делят ширину равномерно */\n.discount-buttons .discount-button { flex: 1 1 0; }\n\n.discount-button:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.2);\n  transform: translateY(-1px);\n}\n\n.discount-button--active {\n  background: rgba(195, 255, 25, 0.12);\n  color: #C3FF19;\n  border-color: rgba(195, 255, 25, 0.4);\n  font-weight: 700;\n}\n\n.discount-button--active:hover {\n  background: rgba(195, 255, 25, 0.18);\n  border-color: rgba(195, 255, 25, 0.5);\n  transform: translateY(-1px);\n}\n\n/* Input-styled discount button occupying same slot */\n.discount-button-input {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n  padding: 16px 24px;\n  border-radius: 12px;\n  font-size: 18px;\n  font-weight: 700;\n  font-family: 'Inter', sans-serif;\n  width: 100%;\n  max-width: 140px;\n  transition: all 0.3s ease;\n  text-align: center;\n}\n\n.discount-button-input:focus {\n  border-color: #C3FF19;\n  box-shadow: 0 0 0 4px rgba(195, 255, 25, 0.1);\n  background: rgba(255, 255, 255, 0.08);\n  outline: none;\n}\n/* Discount input styled like fields */\n.discount-input-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 0;\n}\n\n.discount-input {\n  width: 100%;\n  padding: 16px 20px;\n  border: 2px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  font-size: 16px;\n  background: rgba(255, 255, 255, 0.05);\n  color: #ffffff;\n  transition: all 0.3s ease;\n  outline: none;\n  backdrop-filter: blur(10px);\n  text-align: center;\n  font-weight: 600;\n}\n\n.discount-input:focus {\n  border-color: #C3FF19;\n  box-shadow: 0 0 0 4px rgba(195, 255, 25, 0.1);\n  background-color: rgba(255, 255, 255, 0.08);\n}\n\n.discount-percent-sign {\n  color: #C3FF19;\n  font-weight: 700;\n}\n\n/* New discount rate input like hourly input with +/- */\n.discount-rate-input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-top: 0;\n}\n\n.discount-rate-input-container.inline {\n  flex: 1 1 auto;\n}\n\n.discount-rate-input {\n  width: 100%;\n  padding: 16px 20px;\n  padding-right: 90px;\n  border: 2px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  font-size: 16px;\n  background: rgba(255, 255, 255, 0.05);\n  color: #ffffff;\n  transition: all 0.3s ease;\n  outline: none;\n  backdrop-filter: blur(10px);\n  text-align: center;\n  font-weight: 600;\n}\n\n.discount-rate-input:focus {\n  border-color: #C3FF19;\n  box-shadow: 0 0 0 4px rgba(195, 255, 25, 0.1);\n  background-color: rgba(255, 255, 255, 0.08);\n}\n\n.discount-rate-input::-webkit-outer-spin-button,\n.discount-rate-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.discount-rate-input[type=number] {\n  appearance: textfield;\n  -moz-appearance: textfield;\n}\n\n.discount-rate-controls-horizontal {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n}\n\n.discount-rate-control-btn {\n  background: rgba(195, 255, 25, 0.1);\n  border: 1px solid rgba(195, 255, 25, 0.2);\n  color: #C3FF19;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 32px;\n  min-height: 32px;\n}\n\n.discount-rate-control-btn:hover:not(:disabled) {\n  background: rgba(195, 255, 25, 0.2);\n  border-color: rgba(195, 255, 25, 0.3);\n  box-shadow: 0 0 10px rgba(195, 255, 25, 0.15);\n}\n\n/* Urgency buttons styles (match Discount buttons) */\n.urgency-buttons {\n  display: flex;\n  gap: 16px;\n  margin-top: 0;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.urgency-button {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n  padding: 16px 28px; /* больше пространства для текста */\n  border-radius: 12px;\n  font-size: 16px; /* как у дропдаунов */\n  font-weight: 600;\n  font-family: 'Inter', sans-serif;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  flex: 1;\n  min-width: 80px;\n  min-height: 52px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n}\n\n.urgency-button:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.2);\n  transform: translateY(-1px);\n}\n\n.urgency-button--active {\n  background: rgba(195, 255, 25, 0.12);\n  color: #C3FF19;\n  border-color: rgba(195, 255, 25, 0.4);\n  font-weight: 700;\n}\n\n.urgency-button--active:hover {\n  background: rgba(195, 255, 25, 0.18);\n  border-color: rgba(195, 255, 25, 0.5);\n  transform: translateY(-1px);\n}\n\n/* Estimated hours styles */\n.estimated-hours {\n  margin-top: 16px; /* уменьшили расстояние от цен */\n  padding: 20px 24px;\n  background: rgba(255, 255, 255, 0.02);\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: all 0.3s ease;\n}\n\n.estimated-hours:hover {\n  background: rgba(255, 255, 255, 0.04);\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n.estimated-hours-label {\n  font-size: 1rem;\n  color: #a0a0a0;\n  font-weight: 400;\n  letter-spacing: 0.5px;\n}\n\n.estimated-hours-value {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #ffffff;\n  opacity: 0.8;\n}\n\n/* Hourly rate input styles */\n.hourly-rate-input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.hourly-rate-input {\n  width: 100%;\n  padding: 16px 20px;\n  padding-right: 90px;\n  padding-left: 56px; /* как у варианта с кнопкой, аналогично +/- по ширине */\n  border: 2px solid rgba(195, 255, 25, 0.3);\n  border-radius: 16px;\n  font-size: 18px;\n  background: rgba(195, 255, 25, 0.05);\n  color: #C3FF19;\n  transition: all 0.3s ease;\n  outline: none;\n  backdrop-filter: blur(10px);\n  text-align: center;\n  font-weight: 700;\n  font-family: 'Druk Wide Bold', 'Inter', sans-serif;\n}\n\n.hourly-rate-control-btn {\n  position: absolute;\n  background: rgba(195, 255, 25, 0.1);\n  border: 1px solid rgba(195, 255, 25, 0.2);\n  color: #C3FF19;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 32px;\n  min-height: 32px;\n  z-index: 2;\n}\n\n.hourly-rate-control-btn:hover:not(:disabled) {\n  background: rgba(195, 255, 25, 0.2);\n  border-color: rgba(195, 255, 25, 0.3);\n  box-shadow: 0 0 10px rgba(195, 255, 25, 0.15);\n}\n\n.hourly-rate-control-btn:active:not(:disabled) {\n  transform: scale(0.95);\n}\n\n.hourly-rate-control-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.hourly-rate-control-btn:disabled:hover {\n  transform: none;\n  box-shadow: none;\n}\n\n/* Горизонтальные кнопки для hourly rate */\n.hourly-rate-controls-horizontal {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n}\n\n/* Позиционирование кнопок для hourly rate */\n.hourly-rate-input-container .hourly-rate-control-btn:first-child {\n  position: static;\n  transform: none;\n}\n\n.hourly-rate-input-container .hourly-rate-control-btn:last-child {\n  position: static;\n  transform: none;\n}\n\n.hourly-rate-input:focus {\n  border-color: #C3FF19;\n  box-shadow: 0 0 0 4px rgba(195, 255, 25, 0.2);\n  background-color: rgba(195, 255, 25, 0.08);\n  transform: none;\n}\n\n.hourly-rate-input:hover {\n  border-color: rgba(195, 255, 25, 0.5);\n  background-color: rgba(195, 255, 25, 0.08);\n}\n\n/* Inline currency select styled as our custom select */\n/* Кнопка валюты внутри поля (как +/-) */\n.currency-inline-wrapper {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  height: 32px; /* как у кнопок +/- */\n  padding-left: 12px; /* отступ от левого края поля */\n  padding-right: 12px; /* симметрично справа, чтобы dropdown совпадал по ширине */\n  z-index: 10001;\n  pointer-events: none; /* кликабельной будет только кнопка */\n}\n.currency-inline { width: 100%; margin-bottom: 0; }\n\n.currency-inline .custom-select__header {\n  height: 32px; /* как у кнопок +/- */\n  min-height: 32px !important; /* перекрываем базовый min-height 56px */\n  min-width: 40px;\n  box-sizing: border-box;\n  padding: 8px; /* как у +/- */\n  border: 1px solid rgba(195, 255, 25, 0.2);\n  background: rgba(195, 255, 25, 0.1); /* как у +/- */\n  border-radius: 8px;\n  display: inline-flex; /* не растягиваем на всю ширину */\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  pointer-events: auto; /* кликабельна */\n  width: auto !important; /* фиксируем авто-ширину */\n  color: #C3FF19; /* как у +/- */\n  font-size: 16px;\n  line-height: 16px;\n  font-weight: 600;\n}\n.currency-inline .custom-select__arrow {\n  width: 16px; /* по требованию */\n  height: 16px; /* по требованию */\n  display: inline-flex;\n  align-items: center;\n}\n\n.currency-inline__value {\n  color: #C3FF19;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  line-height: 14px; /* вписываемся в 16px высоты */\n}\n\n.currency-inline__dropdown {\n  left: 0 !important;\n  right: 0 !important; /* на всю ширину wrapper, который совпадает с полем */\n  min-width: 100% !important;\n  z-index: 10002; /* поверх всего */\n}\n\n/* Сблизить стрелку с символом и убрать лишний отступ справа */\n.currency-inline .custom-select__arrow {\n  margin-left: 4px !important;\n}\n\n/* Убираем обводки/outline у дропдауна валюты */\n.currency-inline .custom-select__header,\n.currency-inline .custom-select__header:focus,\n.currency-inline .custom-select__header:active {\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.currency-inline .custom-select__header:hover {\n  transform: none;\n  background: rgba(195, 255, 25, 0.2); /* как у +/- */\n  border-color: rgba(195, 255, 25, 0.3);\n  box-shadow: 0 0 10px rgba(195, 255, 25, 0.15);\n}\n\n/* Отключаем любые эффекты на кнопке при открытии; анимация остаётся только у иконки */\n.currency-inline .custom-select__header--open {\n  border: 1px solid rgba(195, 255, 25, 0.2);\n  box-shadow: none;\n  background-color: rgba(195, 255, 25, 0.1);\n  transform: none;\n}\n\n.currency-inline .custom-select__header:active {\n  transform: scale(0.95);\n}\n\n.hourly-rate-input::-webkit-outer-spin-button,\n.hourly-rate-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.hourly-rate-input[type=number] {\n  appearance: textfield;\n  -moz-appearance: textfield;\n}\n\n/* Hourly rate display styles (for results) */\n.hourly-rate {\n  margin-top: 20px;\n  padding: 20px 24px;\n  background: rgba(195, 255, 25, 0.05);\n  border-radius: 12px;\n  border: 1px solid rgba(195, 255, 25, 0.1);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: all 0.3s ease;\n}\n\n.hourly-rate:hover {\n  background: rgba(195, 255, 25, 0.08);\n  border-color: rgba(195, 255, 25, 0.15);\n}\n\n.hourly-rate-label {\n  font-size: 1rem;\n  color: #a0a0a0;\n  font-weight: 400;\n  letter-spacing: 0.5px;\n}\n\n.hourly-rate-value {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #C3FF19;\n  opacity: 0.9;\n}\n\n/* Version info styles */\n.version-info {\n  margin-top: 60px;\n  padding: 20px 0;\n  text-align: center;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  background: rgba(0, 0, 0, 0.1);\n}\n\n/* Расширение фона футера на нижнюю безопасную область */\n.footer-extension {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: env(safe-area-inset-bottom);\n  height: constant(safe-area-inset-bottom);\n  background: rgba(0, 0, 0, 0.1);\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  pointer-events: none;\n  z-index: 1;\n}\n\n.version-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.version-main {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n}\n\n.version-text {\n  font-size: 0.75rem;\n  font-weight: 400;\n  color: #666666;\n}\n\n.version-copyright {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.copyright-text {\n  font-size: 0.65rem;\n  color: #555555;\n  font-weight: 300;\n}\n\n@media (max-width: 1200px) {\n  .main-content {\n    max-width: 1000px;\n    gap: 30px;\n  }\n  \n  .form-section {\n    width: 550px;\n    padding: 40px;\n  }\n  \n  .results-section {\n    width: 340px;\n  }\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 20px 16px;\n    flex: 1;\n  }\n  \n  .main-content {\n    flex-direction: column;\n    gap: 20px;\n    align-items: center;\n  }\n  \n  /* Заголовки и подзаголовок на мобильных */\n  .header h1 {\n    font-size: 3.2rem;\n    line-height: 1.05;\n  }\n  .header p {\n    font-size: 0.85rem;\n    line-height: 1.4;\n  }\n  \n  /* Исправляем проблемы с dropdown на мобильных */\n  .custom-select__dropdown {\n    z-index: 99999 !important;\n    background: #1a1a1a !important;\n    background-color: #1a1a1a !important;\n    position: fixed !important;\n    top: auto !important;\n    left: 16px !important;\n    right: 16px !important;\n    max-height: 300px !important;\n    overflow-y: auto !important;\n    opacity: 1 !important;\n    pointer-events: auto !important;\n    transform: none !important;\n    transition: none !important;\n  }\n  /* Дропдаун валюты — те же правила, во всю ширину поля/экрана */\n  .currency-inline__dropdown {\n    z-index: 99999 !important;\n    background: #1a1a1a !important;\n    background-color: #1a1a1a !important;\n    position: absolute !important; /* от контейнера валюты */\n    top: calc(100% + 8px) !important; /* под кнопкой валюты */\n    left: 0 !important;\n    right: 0 !important; /* ровно по ширине input (через wrapper) */\n    max-height: 300px !important;\n    overflow-y: auto !important;\n    opacity: 1 !important;\n    pointer-events: auto !important;\n    transform: none !important;\n    transition: none !important;\n  }\n  \n  /* На мобильных все dropdown имеют одинаковый z-index */\n  .form-group .custom-select {\n    z-index: 1 !important;\n  }\n  \n  /* Когда dropdown открыт на мобильных */\n  .form-group .custom-select:has(.custom-select__dropdown) {\n    z-index: 99999 !important;\n  }\n  \n  .form-section {\n    width: 100%;\n    max-width: 500px;\n    padding: 32px 24px;\n    order: 2;\n  }\n  \n  .results-section {\n    position: static;\n    width: 100%;\n    max-width: 500px;\n    padding: 32px 24px; /* те же паддинги, что у form-section */\n    order: 1;\n    margin-top: 0;\n  }\n\n  /* Цены в столбик на мобильных */\n  .result-prices { flex-direction: column; gap: 16px; align-items: stretch; }\n  .price-item {\n    padding: 20px 24px;\n    border-radius: 12px;\n  }\n  .price-value { font-size: 1.2rem; }\n\n  /* Компактный empty state */\n  .empty-state { padding: 12px 8px; }\n  .empty-state h3 { font-size: 1rem; margin-bottom: 4px; }\n  .empty-state p { font-size: 0.8rem; }\n  \n  /* Убираем дублирующиеся стили для results-column */\n  \n  .header h1 {\n    font-size: 2.5rem;\n  }\n  \n  .button-group {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .btn {\n    width: 100%;\n    max-width: 300px;\n  }\n  \n  .price-value {\n    font-size: 1.2rem;\n  }\n  \n  .copy-button {\n    min-width: 40px;\n    min-height: 40px;\n    padding: 8px;\n  }\n  \n  .number-control-btn {\n    min-width: 28px;\n    min-height: 28px;\n    padding: 6px;\n  }\n  \n  .number-input-field {\n    padding-right: 70px;\n  }\n\n  .version-info {\n    margin-top: 80px; /* увеличили расстояние от контента до футера */\n    padding: 16px 0;\n    margin-bottom: 88px; /* чуть больше для плавающей кнопки */\n  }\n  \n  .version-main {\n    flex-direction: column;\n    gap: 4px;\n  }\n  \n  .version-copyright {\n    flex-direction: column;\n    gap: 4px;\n  }\n  \n  /* Показываем плавающую кнопку Reset на мобильных */\n  .floating-reset-button {\n    display: flex;\n  }\n  \n  /* Скрываем обычную кнопку Reset на мобильных */\n  .reset-button {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
